import APIService from "./APIService";
import { API_BASE_URL } from "../../../config/apiConfig";

const BASE_URL = "/api/v1/admin/events";

/**
 * Platform-admin events API. Every call requires the platform_admin role;
 * the backend @RequireRole aspect is the actual boundary.
 */
const EventAdminService = {
  listEvents: () => APIService.get(BASE_URL),

  getEvent: (id) => APIService.get(`${BASE_URL}/${id}`),

  createEvent: (payload) => APIService.post(BASE_URL, payload),

  updateEvent: (id, payload) => APIService.put(`${BASE_URL}/${id}`, payload),

  /**
   * @param {"publish"|"unpublish"|"cancel"|"complete"|"clone"|"delete"} action
   * @param {Object} [payload] extra body fields — `reason` for cancel
   */
  eventAction: (id, action, payload = {}) =>
    APIService.post(`${BASE_URL}/${id}/action`, { action, ...payload }),

  getStats: (id) => APIService.get(`${BASE_URL}/${id}/stats`),

  listRegistrants: (id, query) =>
    APIService.get(
      `${BASE_URL}/${id}/registrants${query ? `?q=${encodeURIComponent(query)}` : ""}`,
    ),

  /** @param {"add"|"checkin"|"promote-waitlist"|"cancel"} action */
  registrantAction: (id, action, payload = {}) =>
    APIService.post(`${BASE_URL}/${id}/registrants/action`, {
      action,
      ...payload,
    }),

  /** @param {"confirmation"|"reminder"|"followup"|"recap"|"cancellation"} action */
  sendCampaign: (id, action) =>
    APIService.post(`${BASE_URL}/${id}/campaign`, { action }),

  /** CSV is a browser download, so it goes through a direct authenticated fetch. */
  exportUrl: (id) => `${API_BASE_URL}${BASE_URL}/${id}/export`,

  listHostRequests: () => APIService.get(`${BASE_URL}/host-requests`),

  updateHostRequest: (id, status) =>
    APIService.post(`${BASE_URL}/host-requests/${id}`, { status }),
};

export default EventAdminService;
